/**
 * Identità client anonima per la presence (conteggio utenti connessi).
 *
 * UUID generato una volta e persistito in localStorage (`mojito.clientId`),
 * inviato come header `X-Client-Id` (vedi lib/api.js). Non-PII: serve solo a
 * distinguere i device per il conteggio aggregato, risolvendo il problema
 * NAT/WiFi (più client dietro lo stesso IP) e degli IP mobili che cambiano.
 *
 * Singleton a livello modulo. In private mode / senza localStorage l'id è
 * volatile per sessione (fallback in memoria).
 */

const KEY = 'mojito.clientId'

function generate () {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Fallback RFC4122-ish (browser vecchi o contesto non sicuro).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

let cached = null

export function getClientId () {
  if (cached) return cached
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = generate()
      localStorage.setItem(KEY, id)
    }
    cached = id
  } catch {
    cached = generate()
  }
  return cached
}
